module.exports = __webpack_public_path__ + "static/media/mark-price.9956c501.jpg";